import { render, staticRenderFns } from "./fidelior-about.vue?vue&type=template&id=2a212583&"
import script from "./fidelior-about.vue?vue&type=script&lang=js&"
export * from "./fidelior-about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports